export enum TimePeriod {
	'Day' = 'DAY',
	'Week' = 'WEEK',
	'Month' = 'MONTH',
	'LastMonth' = 'LAST_MONTH',
	'Ytd' = 'YTD',
}
